module.exports = __webpack_public_path__ + "media/V94.e24e420b.mp4";